import React, { useEffect, useState, useRef, useContext } from 'react';
import { IonItem, IonButton, IonSlides, IonGrid, IonTabs, IonTab, IonTabBar, IonTabButton, IonToolbar, IonTitle, IonContent, IonHeader, IonLabel, IonRouterOutlet, IonFooter, IonCard, IonModal, IonLoading } from '@ionic/react';
import { IonSlide, IonRow, IonCol, IonImg } from '@ionic/react';
import { useHistory} from "react-router-dom";

import '../css/zPublic.css';
import '../../css/layout.css';

import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';
import { MerchantLoginCredentials } from '../components/LoginCredentials_merchant';
import { Reservation_EnterBookingInfo } from './Reservation_EnterBookingInfo_locals';
import { Enlarge_Image } from './EnlargeImage';
import { Jobs } from './Jobs';
import {CachedImage} from './Component_CachedImage'; // Import CachedImage component


export function Hotels_Homepage (props) {

        let authMerchant_objects = useContext(Auth_MerchantID_context);

        let [baseURL, setBaseURL ] = useState(authMerchant_objects.baseURL);


        let [customerRating, setCusotmerRating] = useState('0.00000');
        let [viewHotelRooms_showcase, setViewHotelRooms_showcase] = useState([]);

        //let [showcaseGalleryTracker, setShowcaseGalleryTracker] = useState(null);
        let [merchantLoginModal, setMerchantLoginModal] = useState(false);
        let [inputReservationInfoModal, setInputReservationInfoModal] = useState(false);
        let {enlargeImageModal, setEnlargeImageModal} = useState(false);

        let [roomID, setRoomID] = useState(props.data.roomID);
        let [image, setImage] = useState(null);

        let [isloading, setLoading] = useState(false);

        let [jobsData, setJobsData] = useState(false);


        let history = useHistory();

        let currentShowcaseCategoryRef = useRef('main');


        let merchant_ID = props.data.companyId;


        useEffect(() => {

            setLoading(true);


                setViewHotelRooms_showcase([]);

                let requestOptions3= {
                    method: 'POST',
                    //credentials: 'include',
                    headers: {
                        'Accept': 'text/html, application/json',
                        'content-type': 'application/json',
                     },
                    body: JSON.stringify({
                        Tracker: "0002AA_hotel",
                        merchantID: merchant_ID,
                    }),
                }
                //alert("IN USEEFECT HOMPATE HOTEL2");
                //alert(baseURL);

                fetch(baseURL+'merchants_argsApp', requestOptions3)
                .then(res => res.text())
                .then(res => {

                    let rows = res.toString().split('~~~');

                    for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                    {
                        let cols = rows[rownum].split('|');

                            setViewHotelRooms_showcase((prevViewHotelRooms_showcase) => {
                                return prevViewHotelRooms_showcase.concat({
                                    roomID: cols[0], 
                                    image: cols[1]
                                })
                            });
                    }
    
                        setLoading(false);

                });

            }, [])


            function enterReservationModalHandler(event) 
            {


                setRoomID(event[1]);
                setImage(event[2]);
                //setEnlargeImageModal(event[0]);
                setInputReservationInfoModal(event[0]);

            }

            const handleHomepage = () => {

                if(authMerchant_objects.authenticated == 'T1')
                {
                    history.push('/hotel_merchantMainPageApp'); 
                    window.location.href = '/hotel_merchantMainPageApp';
                }
          };

         //  alert("In Homepage Hotel");
         //  alert(props.data.companyId);
        //   alert(authMerchant_objects.acctID);

            return (
                <React.Fragment>
                <IonModal isOpen={true}>
                    <IonHeader>
                        <IonGrid >
                            <IonRow className='gh_homepage_top_links_row'>
                                <IonCol className='zPub_list_gridCol_title' style={{ textAlign: 'center' }}>{props.data.companyName+' HOTEL'}</IonCol>

                                <IonCol className='gh_homepage_top_links_col' size='3' style={{ textAlign: 'right' }}>
                                    {authMerchant_objects.authenticated == null && <IonButton  className='small_button' onClick={() => setMerchantLoginModal(true)}> Login </IonButton>}
                                    {authMerchant_objects.authenticated != null && <IonButton  className='small_button' onClick={() => handleHomepage()}> Homepage </IonButton>}
                                </IonCol>
                            </IonRow>
                            <IonRow >
                                <IonCol className='zPub_list_gridCol_address'>{props.data.companyAddressNumber + " " + props.data.companyStreetName+" * "+props.data.companyCity + ", " +props.data.companyCityDistrict}</IonCol>
                            </IonRow>
                            <IonRow >
                                <IonCol className='zPub_list_gridCol_address'>{props.data.companyEmail+" * "+props.data.companyPhoneNumber}</IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonHeader>
                    <IonContent className='merchantList_Content_showcase'>
                    <div className='zShowcase_list'>

                    { viewHotelRooms_showcase.length > 0 && viewHotelRooms_showcase.map((detailData) =>   {
                                    return (
                                        <IonCard className='card_merchantList_showcase' onClick={ () => enterReservationModalHandler([true, detailData.roomID, detailData.image])}>
 
                                            <div className='zShowcase_img_div'>
                                                
                                                {/*<CachedImage  
                                                imageUrl={detailData.image}
                                                fileName={detailData.image} 
                                                className="zShowcase_img_inside"
                                                alt="Example Cached Image"
                                                ></CachedImage>*/}
                                                <IonImg className="zShowcase_img_inside" src={`/api/image/${detailData.image}/${props.data.companySchema}`} />
                                            </div>

                                        </IonCard>
                    );
                                })}

                    </div>

                    {isloading == true && <IonLoading
                                        isOpen={isloading}
                                        message={'Please wait...'}
                                        duration={0} // Show until manually dismissed
                                    />}

                    </IonContent>
                    <IonFooter class='hotelShowcaseFooter'>
                        <IonGrid>
                            <IonRow >
                                <IonCol size='4'>
                                    <IonButton onClick={() => setInputReservationInfoModal(true)}>Book</IonButton>
                                </IonCol>
                                {/*<IonCol size='4'>
                                    <IonButton href='https://bluefinhoteltest.com'>Site</IonButton>
                                </IonCol>*/}
                                <IonCol size='4'>
                                    <IonButton onClick={() => setJobsData(true)}>Jobs</IonButton>
                                </IonCol>
                                <IonCol size='4'>
                                    <IonButton onClick={() => props.closeModal()}>Close</IonButton>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonFooter>

                    {merchantLoginModal == true && <MerchantLoginCredentials openModal={ merchantLoginModal } closeModal={() => setMerchantLoginModal(false)} ></MerchantLoginCredentials>}

                </IonModal>


                {enlargeImageModal == true && <Enlarge_Image openModal={ enlargeImageModal } closeModal={() => setEnlargeImageModal(false)} data={{
                                                                    companyID: props.data.companyId,
                                                                    roomID: roomID, 
                                                                    //image: image,
                                                                    }} ></Enlarge_Image>}

                {jobsData == true && <Jobs openModal={ jobsData } closeModal={() => setJobsData(false)} data={{
                    status: "ghanaverified_site",
                    }}></Jobs>}   

                {inputReservationInfoModal == true &&   <Reservation_EnterBookingInfo openModal={ inputReservationInfoModal } closeModal={() => setInputReservationInfoModal(false)}  tracker={"PUBLIC_74701"} data={{
                        companyID: props.data.companyId,
                        companyPhoneNumber: props.data.companyPhoneNumber,
                        roomID: roomID, 
                        roomSalePrice: '',
                        }}></Reservation_EnterBookingInfo> }
                

                        
            </React.Fragment>
    
            )
        //}


    }
